<h1 mat-dialog-title>
  {{title | translate}}
</h1>
<div mat-dialog-content>
  <p [innerHtml]="message"></p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null">{{'CLOSE' | translate}}</button>
</div>